export const CARD_COLORS = {
    black: '#000',
    paper: '#fff',
    ink: '#1d1d1b',
    inkSoft: '#3a3a37',
    label: '#5f5f5a',
    muted: '#6b6b66',
    struck: '#8a8a85',
    disabledText: '#8e8e89',
    markBorder: '#9a9a95',
    chipBorder: '#bdbdb8',
    disabledIcon: '#c4c4bf',
    inputBorder: '#c9c9c4',
    panelBorder: '#d6d6d1',
    segment: '#dcdcd7',
    boxBorder: '#e1e1dc',
    disabled: '#e6e6e3',
    divider: '#e7e7e3',
    hover: '#ececea',
    logDivider: '#efefeb',
    card: '#f1f1ee',
    locked: '#f6f6f3',
    side: '#fafaf8',
    green: '#1b6b30',
    paid: '#2e7d32',
    approvedText: '#1b5e20',
    greenBorder: '#4caf50',
    doneBorder: '#9fd3a8',
    doneBg: '#f3fbf4',
    answeredBg: '#edf5ee',
    answeredText: '#1b4d1e',
    statusOkBg: '#c8e6c9',
    statusRejectBg: '#f6d3d1',
    statusRejectText: '#7a1f1a',
    statusWaitBg: '#ffe0b2',
    statusWaitText: '#5a3a00',
    statusPendingText: '#1a1a1a',
    rejectFill: '#8e2a22',
    redChip: '#a8231b',
    red: '#b3261e',
    redMark: '#c62828',
    redBorder: '#e57373',
    stopBorder: '#efb7b2',
    redBg: '#fff5f4',
    stopBg: '#fff6f5',
    amber: '#7a4f00',
    amberMark: '#e0a100',
    changedBorder: '#d9a400',
    waitBorder: '#ecd28e',
    amberBg: '#fff8e1',
    waitBg: '#fffaf0',
    changedText: '#fff3c4',
    changedBg: '#fffbea',
    warnText: '#5c3b00',
    warnBg: '#fff4e0',
    blue: '#1f4fa3',
    blueBorder: '#8fb0e6',
    blueBg: '#f2f6fd',
    noteText: '#1f3f73',
    noteBg: '#e9f1fc',
    withdrawnBg: '#ededea',
    withdrawnText: '#2a2a28',
    withdrawnValue: '#4a4a48',
    closedBg: '#f5f5f3',
    closedBorder: '#dadad6',
    panelDivider: '#ecece8',
    fieldBorder: '#bdbdb8',
    fieldDisabledBg: '#e9e9e6',
    fieldDisabledBorder: '#d4d4d0',
} as const
